import React from 'react';

import { AppSettingsContext, SessionContext, HttpClientContext, ScreenSizeContext, SnackbarContext, ConfirmContext, AuthContext } from '@dw/contexts';

export { useRouteData } from './useRouteData';
export { useBinaryToggle } from './useBinaryToggle';
export { useFileUploader } from './useFileUploader';
export type { IFileUploadOptions } from './useFileUploader';
export { useVoiceNoteUploader } from './useVoiceNoteUploader';
export { useVoiceNoteComposer } from './useVoiceNoteComposer';
export { useStorage } from './useStorage';
export { useSessionStorage } from './useSessionStorage';
export { useActiveEnrolmentYear } from './useActiveEnrolmentYear';
export { useUnsavedChangesGuard, UNSAVED_ORDER_CONFIRM } from './useUnsavedChangesGuard';
export { useSignOut } from './useSignOut';

export const useAppSettings = () => React.useContext(AppSettingsContext);
export const useHttpClient = () => React.useContext(HttpClientContext);
export const useSnackbar = () => React.useContext(SnackbarContext);
export const useSession = () => React.useContext(SessionContext);
export const useScreenSize = () => React.useContext(ScreenSizeContext);
export const useConfirm = () => React.useContext(ConfirmContext);
export const useAuth = () => React.useContext(AuthContext);